import React from 'react';

import { FormErrorsContext } from './context';
import type { FormErrorsContextType } from './types';

export function FormErrorsProvider({ children }: { children: React.ReactNode }) {
  const [errors, setErrors] = React.useState<FormErrorsContextType['errors']>({});

  const value: FormErrorsContextType = React.useMemo(
    () => ({
      errors,
      setErrors: (newErrors) => {
        setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
      },
      resetErrors: () => {
        if (Object.keys(errors).length > 0) {
          setErrors({});
        }
      },
    }),
    [errors, setErrors]
  );

  return <FormErrorsContext value={value}>{children}</FormErrorsContext>;
}
